export default __webpack_public_path__ + "img/employee-lists.d731a1.svg";